import ApplicationSerializer from 'teacher-ui-client/serializers/application'

export default class TeacherSubscriptionSerializer extends ApplicationSerializer {}
